import { useCallback, useMemo } from 'react'
import { generatePath, useParams } from 'react-router-dom'
import { useApiQuery } from 'admin/lib/Api'
import { Layout } from 'admin/lib/Layouts'
import { Breadcrumb, BreadcrumbArrayItem } from 'admin/lib/Breadcrumbs'
import { ScreenSpin } from 'admin/lib/ScreenSpin'
import * as ROUTES from 'admin/routes'
import { GetPageNames } from 'admin/lib/GetPageNames'

import { NotificationList } from './NotificationList'

export function Notifications() {
  const { accountId, projectId } = useParams()

  const account = useApiQuery(
    useCallback(api => api.getAccount(accountId), [accountId])
  )
  const project = useApiQuery(
    useCallback(
      api => api.getProject(accountId, projectId),
      [accountId, projectId]
    )
  )

  const context = useMemo(() => {
    return {
      loaded: account.loaded && project.loaded,
      account: account.data,
      project: project.data
    }
  }, [account.data, account.loaded, project.data, project.loaded])

  const notifications = useApiQuery(
    useCallback(
      api => {
        return api.listNotifications(accountId, projectId)
      },
      [accountId, projectId]
    )
  )

  const pageNames = GetPageNames(accountId, projectId)

  return (
    <Layout
      header={
        <Breadcrumb
          items={[
            {
              title: (
                <BreadcrumbArrayItem href={generatePath(ROUTES.ACCOUNTS.LIST)}>
                  Accounts
                </BreadcrumbArrayItem>
              )
            },
            {
              title: (
                <BreadcrumbArrayItem
                  loading={!context.loaded}
                  href={generatePath(ROUTES.PROJECTS.LIST, {
                    accountId: accountId
                  })}
                >
                  {pageNames.data && pageNames.data.accountName}
                </BreadcrumbArrayItem>
              )
            },
            {
              title: (
                <BreadcrumbArrayItem
                  href={generatePath(ROUTES.PROJECTS.LIST, {
                    accountId: accountId
                  })}
                >
                  Projects
                </BreadcrumbArrayItem>
              )
            },
            {
              title: (
                <BreadcrumbArrayItem loading={!context.loaded}>
                  {pageNames.data && pageNames.data.projectName}
                </BreadcrumbArrayItem>
              )
            },
            {
              title: 'Notifications'
            }
          ]}
        />
      }
    >
      {!notifications.loaded && <ScreenSpin />}

      {notifications.error && (
        <div>
          Something went wrong:{' '}
          {String(notifications.error.response?.data ?? notifications.error)}
        </div>
      )}

      {notifications.loaded && notifications.data && (
        <NotificationList
          notifications={notifications.data}
          accountId={accountId}
          projectId={projectId}
        />
      )}
    </Layout>
  )
}
